import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Context } from 'states/Store';
import i18next from 'i18next';
import useStyles from '../demandes/dossierModel/DossierModelTabStyle';
import { getContextModel } from 'services/edge/ContexteService';
import { useQuery } from 'config/Config';
import { useHistory, useLocation } from 'react-router-dom';
import ContexteModelCreateDialog from './contexteCreation/ContexteCreationContainer';
import ContextModelList from './ContextModelList';
import DataTableButton from '../../../components/common/datatable/DataTableButtons';
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../../services/common/RolesUtils';

function ContextModelTab() {
  const { classes } = useStyles();
  const { hasAnyOfPrivileges } = useContext(RoleBasedAccessControlContext);
  const history = useHistory();
  const location = useLocation();
  const [state, dispatch] = useContext(Context);
  const contexteModelList = state.contextModels;

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(
    !!useQuery().get('create') || false
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (isCreateDialogOpen) {
      searchParams.set('create', true);
    } else {
      searchParams.delete('create');
    }
    history.push({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
    // eslint-disable-next-line
  }, [isCreateDialogOpen]);

  const fetchContexteModelList = useCallback(async () => {
    await getContextModel(state.account.id, dispatch);
  }, [state.account, dispatch]);

  useEffect(() => {
    if (state.account) {
      fetchContexteModelList();
    }
  }, [state.account, fetchContexteModelList]);

  const onValidateSuccess = () => {
    setIsCreateDialogOpen(false);
    fetchContexteModelList();
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          position: "absolute",
          top: "34px",
          right: "25px",
        }}
      >
        <DataTableButton
          onClickHandler={() => setIsCreateDialogOpen(true)}
          label={i18next.t('demandes.dossierModel.createModel')}
          disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_CREATE_CONTEXT_MODEL)}
        />
      </div>
      <div className={classes.rootDatatable}>
        {contexteModelList ? (
          <ContextModelList
            contextModelList={contexteModelList}
            onValidateSuccess={onValidateSuccess}
          />
        ) : (
          <></>
        )}
      </div>
      {isCreateDialogOpen && (
        <ContexteModelCreateDialog
          onClose={() => setIsCreateDialogOpen(false)}
          onValidateSuccess={onValidateSuccess}
        />
      )}
    </div>
  );
}

export default ContextModelTab;
